ApplyCancelButtons = require 'components/common/apply_cancel_buttons'
appUtils = require 'lib/app_utils'
IconButton = require 'components/common/icon_button'
{ isValidJSONFile } = require 'lib/import_utils'
mediator = require 'mediator'
Modal = require 'components/common/modal'
Tooltip = require 'components/common/tooltip'
{ useCoffeeCallback, useCoffeeMemo, useI18n } = require 'lib/react_utils'
{ useRef, useState } = React

ImportJSONQuestionsDialog = ({ isOpen, onClose }) ->
  i18n = useI18n 'projects:import_json_questions_dialog'
  [isImporting, setIsImporting] = useState false
  [file, setFile] = useState null
  fileInputRef = useRef null
  fileFormRef = useRef null

  onChangeFile = (e) ->
    selectedFile = e.target.files[0]
    return unless isValidJSONFile selectedFile
    setFile selectedFile

  _onClose = useCoffeeCallback [onClose], ->
    setIsImporting false
    setFile null
    onClose()

  onImport = useCoffeeCallback [_onClose, file, i18n], ->
    setIsImporting true
    mediator.services.projectImportService.importQuestionsFromJsonFile file
    .then -> mediator.dialogs.info i18n 'import_successful'
    .catch appUtils.errorHandlerWithMsgCurried i18n 'error'
    .finally -> _onClose()

  onButtonClick = useCoffeeCallback [], ->
    fileInputRef.current?.click()

  onResetClick = useCoffeeCallback [], ->
    fileInputRef.current?.value = ''
    fileFormRef.current?.reset()
    setFile null

  fileButtonText = useCoffeeMemo [file, i18n], ->
    if file isnt null
      file.name
    else
      i18n 'choose_file'

  fileTitle = useCoffeeMemo [file], ->
    if file isnt null
      file.name
    else
      ''

  sourceContainerClasses = classNames
    'import-source-button-container': true
    'active': file isnt null

  <Modal
    className="import-modal"
    closeButton={not isImporting}
    isOpen={isOpen}
    modalSize="medium"
    onClose={_onClose}
    title={i18n 'title'}
  >
    <div className="import-choose-source mb-10">
      <div className={sourceContainerClasses}>
        <form ref={fileFormRef}>
          <input
            type="file"
            ref={fileInputRef}
            className="import-source-input-file"
            accept=".json"
            onChange={onChangeFile}
          />
        </form>
        <Tooltip>
          <button
            className="btn btn-apply import-source-button"
            disabled={isImporting}
            onClick={onButtonClick}
            title={fileTitle}
          >
            {fileButtonText}
          </button>
        </Tooltip>
        {file isnt null and <Tooltip>
          <IconButton
            disabled={isImporting}
            onClick={onResetClick}
            iconName="import-source-cross decline-icon"
            title={i18n '/actions.remove'}
          />
        </Tooltip>}
      </div>
    </div>
    <ApplyCancelButtons
      applyLabel={i18n 'import'}
      isApplying={isImporting}
      isCancelEnabled={not isImporting}
      isSubmitEnabled={file isnt null and not isImporting}
      onApply={onImport}
      onCancel={_onClose}
    />
  </Modal>

ImportJSONQuestionsDialog.propTypes =
  isOpen: PropTypes.bool.isRequired
  onClose: PropTypes.func.isRequired

module.exports = ImportJSONQuestionsDialog
